//libs and utilities
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchFooter } from './footer-dux';

/*   Components
 *
 *   1. Footer 
 *
 */

class Footer extends React.Component {
    componentDidMount() {
		this.props.fetchFooter();
    }
    
    render() {
		let footerDetails = this.props.footer;
		let linkList= footerDetails.cmFooterLinkList;
        return(
			<footer>
				{ linkList != undefined &&
					<div className="container">
						<div className={this.props.headerState != null ? "footer-wrapper " +this.props.headerState.paxAudienceType : "footer-wrapper default"}>
							<div className="copyright" dangerouslySetInnerHTML={{ __html: this.props.footer.copyRightCM }} />
							<div className="footer-links">
								<ul>
									{linkList.map((linkName, index) => {
										return <li key={index}>{linkName.status == "A" ? <Link to={ "/"+linkName.url } dangerouslySetInnerHTML={{ __html: linkName.title }} /> : ''}</li>
									})}
								</ul>
							</div>
						</div>
					</div>
				}
			</footer>
        );
    }
}

export default connect(
    ( state ) => {
        return {
            footer: state.footer,
			headerState: state.headerState.audienceType
        };
    },
    ( dispatch ) => bindActionCreators( { fetchFooter }, dispatch )
)( Footer );



// WEBPACK FOOTER //
// ./src/footer/footer.jsx